// extracted by mini-css-extract-plugin
export default {"menuDrawer":"Menu2_menuDrawer__sXPwJ","menuActions":"Menu2_menuActions__qbMmw","menuNavlink":"Menu2_menuNavlink__2g+8v"};